import React, { createContext, useContext, useState, useCallback } from 'react';

const NavigationContext = createContext(null);

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};

export const NavigationProvider = ({ children }) => {
  const [history, setHistory] = useState([]);
  const [currentView, setCurrentView] = useState(null);

  const navigate = useCallback((view, data = {}) => {
    if (currentView && currentView !== view) {
      setHistory((prev) => [...prev, { view: currentView, data }]);
    }
    setCurrentView(view);
  }, [currentView]);

  const goBack = useCallback(() => {
    if (history.length > 0) {
      const newHistory = [...history];
      const previousState = newHistory.pop();
      setHistory(newHistory);
      setCurrentView(previousState.view);
      return previousState;
    }
    return null;
  }, [history]);

  const canGoBack = history.length > 0;

  const clearHistory = useCallback(() => {
    setHistory([]);
  }, []);

  const value = {
    currentView,
    history,
    navigate,
    goBack,
    canGoBack,
    clearHistory,
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationContext;

